<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div class="center-svg"><img src="assets/svg/contact-icon.svg" alt=""></div>
      <div>
        <h4 class="text-semibold">Seleccione una campaña</h4>
        <h6 class="color-gray" style="font-weight: 400;">Elige a qué campaña deseas agregar este contacto</h6>
      </div>
      <div>
        <h3 class="color-gray text-semibold">
          <div class="center-svg">
            <img (click)="closeModal()" class="close-button" src="assets/svg/close-icon.svg" alt="">
          </div>
        </h3>
      </div>
    </div>

    <div class="mdl-body">
      <div class="mt-3">
        <label class="login-label" for="campaign">Campaña:</label>
        <div style="border: solid 1px #D9D9D9; padding: 4px 10px;">
          <div class="d-grid crm-ng-select">
            <div><img src="assets/svg/campaign-icon.svg" alt="icono asignado"></div>
            <div>
              <ng-select 
                [(ngModel)]="selectedCampaign"
                [items]="campaigns"
                bindLabel="name"
                bindValue="id"
                placeholder="Bucar campañas...">
              </ng-select>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row justify-center gap-20 mt-2">
        <button class="btn btn-primary-outline" (click)="closeModal()">Cancelar</button>
        <button class="btn btn-primary" (click)="saveSelection()">Guardar</button>
      </div>
    </div>
  </div>
</div>